import React from 'react';
import { Stack, Typography, Paper } from '@mui/material';
import { useAppSelector } from '../../../../../app/hooks';
import {
  ConditionFieldInput,
  ConditionOperatorSelect,
  ConditionValueInput,
  LogicalOperatorSelect,
  AddConditionButton,
  DeleteConditionButton,
} from '../../ConditionEditor';

export const ConditionsSection: React.FC = () => {
  const currentWorkflow = useAppSelector((state) => state.workflow.currentWorkflow);

  if (!currentWorkflow) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 1.5,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b' }}>
          Conditions (Optional)
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          {currentWorkflow.conditions.length > 0 && <LogicalOperatorSelect />}
          <AddConditionButton />
        </Stack>
      </Stack>

      {currentWorkflow.conditions.length === 0 ? (
        <Typography variant="body2" sx={{ color: '#64748b', fontStyle: 'italic' }}>
          No conditions added. This workflow will trigger for all matching events.
        </Typography>
      ) : (
        <Stack spacing={1}>
          {currentWorkflow.conditions.map((_, index) => (
            <Stack key={index} direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ sm: 'center' }}>
              <ConditionFieldInput index={index} />
              <ConditionOperatorSelect index={index} />
              <ConditionValueInput index={index} />
              <DeleteConditionButton index={index} />
            </Stack>
          ))}
        </Stack>
      )}
    </Paper>
  );
};

export default ConditionsSection;
